import { Branch } from '../base/branch';
import { Cast } from './cast';

export class Syndicate extends Branch {
    static _type: string = 'Syndicate';

    i_syndicate: true = true;

    override load(source?: any): void {
        this.copy(source);

        if (source) {
            const { nodes, branches } = source;

            nodes?.forEach((node: any) => {
                this.nodes.push(new Cast(node));
            });

            branches?.forEach((branch: any) => {
                this.branches.push(new Syndicate(branch));
            });
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Syndicate;
    }
}
